import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { LandingPageState } from './types';

export const actions: ActionTree<LandingPageState, RootState> = {}
